// extracted by mini-css-extract-plugin
module.exports = {"GroupBanner":"GroupBanner_GroupBanner__353Ob","GroupBanner__icon":"GroupBanner_GroupBanner__icon__28NS1"};